import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'redux'
import PropTypes from 'prop-types'
import {resolve} from '@cred/shared/utils'
import CtaButton from './CtaButton'
import spinner from './images/spinner.gif'
import styles from './themes/default/styles.module.scss'
import withForm from '@cred/shared/hoc/with-form'

class SubmitButton extends Component {
  static propTypes = {
    formData: PropTypes.object,
    onClick: PropTypes.func,
    submitting: PropTypes.bool,
    validateOnly: PropTypes.array,
    controlFormData: PropTypes.object,
    formName: PropTypes.string.isRequired
  }

  static defaultProps = {
    formData: null,
    onClick: () => {},
    submitting: false,
    validateOnly: [],
    controlFormData: {}
  }

  static displayName = 'SubmitButton'

  constructor(props) {
    super(props)

    this.state = {validated: false}

    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount() {
    this.updateState(this.props)
  }

  componentDidUpdate() {
    this.updateState(this.props)
  }

  hasErrors(props) {
    const {validateOnly, formData, controlFormData, formName} = props,
      formErrors = formData ? formData.syncErrors : undefined,
      formErrorKeys = formErrors ? Object.keys(formErrors) : [],
      controlFormErrors = controlFormData ? controlFormData.syncErrors : undefined,
      controlErrorKeys = controlFormErrors && controlFormErrors[formName] ? Object.keys(controlFormErrors[formName]) : [],
      errorKeys = formErrorKeys.concat(controlErrorKeys)

    if (validateOnly.length > 0) {
      return !!errorKeys.find(key => validateOnly.includes(key))
    } else {
      return errorKeys.length > 0
    }
  }

  updateState(props) {
    if (this.hasErrors(props)) {
      if (this.state.validated) {
        this.setState({validated: false})
      }
    } else if (!this.state.validated) {
      this.setState({validated: true})
    }
  }

  render() {
    const {formData, onClick, submitting, children, validateOnly, ...props} = this.props

    return (
      <CtaButton
        type="submit"
        disabled={!this.state.validated || submitting}
        onClick={this.handleClick}
        {...props}
      >
        {children} {submitting ? <img src={spinner} className={styles.spinner}/> : null}
      </CtaButton>
    )
  }

  handleClick(e, data) {
    const {onClick, formData, controlFormData} = this.props,
      {validated} = this.state

    if (validated) {
      onClick(e, data)
    } else {
      const formErrors = formData.syncErrors || {},
        controlFormErrors = controlFormData.syncErrors || {},
        syncErrors = {...formErrors, ...controlFormErrors}

      onClick(e, data, syncErrors)
    }
  }
}

const mapStateToProps = state => ({
  controlFormData: resolve('form.control-form', state)
})

export {SubmitButton as SubmitButtonNoHoc}

export default compose(
  withForm,
  connect(mapStateToProps)
)(SubmitButton)
